import React from 'react'
import ContactForm from '../Form/Form'
import css from './SectionForm.module.css'

const SectionForm = () => {
	return (
		<section className={css.formSection}>
			<div className={css.formTitleWrapper}>
				<h2 className={css.formTitle}>POTRZEBUJESZ POMOCY?</h2>
			</div>
			<ContactForm />
		</section>
	)
}

export default SectionForm
